import { render } from "./NoteSpese.vue?vue&type=template&id=c55ea72e&scoped=true"
import script from "./NoteSpese.vue?vue&type=script&lang=js"
export * from "./NoteSpese.vue?vue&type=script&lang=js"

import "./NoteSpese.vue?vue&type=style&index=0&id=c55ea72e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c55ea72e"]])

export default __exports__